import { Directive, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskUtils } from '../utils/mask-util';

@Directive({
  selector: '[campoAdicionalMask]',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CampoAdicionalMaskDirective),
      multi: true
    }
  ]
})
export class CampoAdicionalMaskDirective implements ControlValueAccessor {
  @Input('campoAdicionalMask') tipoSelecao?: number;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: any): void {
    const valorLimpo = this.normalizarValor(value ?? '');
    const valorMascarado = this.aplicarMascara(valorLimpo);

    this.el.nativeElement.value = valorMascarado;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('input')
  onInput(): void {
    const input = this.el.nativeElement;

    const valorLimpo = this.normalizarValor(input.value);
    const valorMascarado = this.aplicarMascara(valorLimpo);

    input.value = valorMascarado;

    this.onChange(valorLimpo);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  private normalizarValor(valor: string): string {
    if (!valor) return '';

    if (this.tipoSelecao === 1) {
      return valor.replace(/\D/g, '').substring(0, 11);
    }

    if (this.tipoSelecao === 2) {
      return valor.replace(/\D/g, '').substring(0, 14); 
    }

    if (this.tipoSelecao === 3) {
      return valor.replace(/\D/g, '').substring(0, 11); 
    }

    if (this.tipoSelecao === 4) {
      return valor
        .replace(/[^a-zA-Z0-9]/g, '')
        .toUpperCase()
        .substring(0, 7); 
    }

    if (this.tipoSelecao === 5 || this.tipoSelecao === 6) {
      return valor.replace(/\D/g, '');
    }

    if (this.tipoSelecao === 7) {
      return valor
        .replace(/[^a-zA-Z0-9]/g, '')
        .toUpperCase()
        .substring(0, 11);
    }

    return valor;
  }

  private aplicarMascara(valor: string): string {
    if (!valor) return '';

    if (this.tipoSelecao === 1) {
      return MaskUtils.cpf(valor);
    }

    if (this.tipoSelecao === 2) {
      return MaskUtils.cnpj(valor);
    }

    if (this.tipoSelecao === 3) {
      return MaskUtils.telefone(valor);
    }

    if (this.tipoSelecao === 4) {
      return MaskUtils.placaVeiculo(valor);
    }

    if (this.tipoSelecao === 5) {
      return MaskUtils.real(valor);
    }

    if (this.tipoSelecao === 6) {
      return MaskUtils.dolar(valor);
    }

    if (this.tipoSelecao === 7) {
      return MaskUtils.container(valor);
    }

    return valor;
  }
}